// @generated
// This file was automatically generated and should not be edited.
// Run `dev generate pipeline-frontend` to regenerate.

/* eslint-disable unused-imports/no-unused-imports */

// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {ColumnTypeValidationFlag} from 'data-frames/util/validateColumnType';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {LeafType} from 'data-types/benchling-type-def/BenchlingTypeDef';
// oxlint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import {PipelineStepDataKind, PipelineStepType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {PipelineStepShape} from 'pipelines/StepShapeUtils';

export const GENERATE_OPENFOLD3_JSON_STEP_SHAPES = [
  {
    stepType: PipelineStepType.GENERATE_OPENFOLD3_JSON,
    isDeprecated: false,
    version: 0,
    inputDataShapes: {},
    outputDataShapes: {
      'Model Hub Job Params JSON File': {
        systemName: 'Model Hub Job Params JSON File',
        displayName: 'Model Hub Job Params JSON File',
        kind: PipelineStepDataKind.FILE,
        isMulti: false,
        isRequired: true
      }
    },
    config: {
      structurePredictionRunId: {
        kind: 'integer',
        required: true
      }
    }
  }
] as const satisfies ReadonlyArray<PipelineStepShape>;
